import React, { FC } from 'react';
import { SizeGuideLoader } from 'src/components/SizeGuide/SizeGuideLoader';
import { WearerBundleDetails } from 'src/queries/__generated__/wearerBundleDetail';

import classes from './BundleSizeGuideAndDetails.scss';

type Props = {
    sizeGuides?: string;
    details?: WearerBundleDetails;
    setIsOpenProductInfoModal: (state: boolean) => void;
    productUrl?: string;
    alwaysOn?: boolean;
};

export const BundleSizeGuideAndDetails: FC<Props> = ({ sizeGuides, details, setIsOpenProductInfoModal }) => (
    <>
        {sizeGuides && (
            <div className={classes.sizeGuide}>
                <SizeGuideLoader sizeGuide={sizeGuides} />
            </div>
        )}
        {details && (
            <button type="button" className={classes.button} onClick={() => setIsOpenProductInfoModal(true)}>
                <div className={classes.content}>
                    Product details
                    <div className={classes.icon} />
                </div>
            </button>
        )}
    </>
);
